import { useQuery } from '@tanstack/react-query'
import { expressCompanyApi } from '@/api/express-company'

export const expressCompanyKeys = {
  all: ['employee', 'express-companies'] as const,
  list: () => [...expressCompanyKeys.all, 'list'] as const,
}

interface UseExpressCompaniesOptions {
  enabled?: boolean
}

/** 获取快递公司列表 */
export function useExpressCompanies(options: UseExpressCompaniesOptions = {}) {
  return useQuery({
    queryKey: expressCompanyKeys.list(),
    queryFn: expressCompanyApi.list,
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000,
  })
}
